<div class="page-layout">
  <app-sidebar></app-sidebar>

  <main class="main-content">
    <header class="page-header">
      <h1 class="page-title">Activity Log</h1>
      <span class="total-count" *ngIf="totalCount > 0">{{ totalCount }} entries</span>
    </header>

    <!-- Filters -->
    <div class="filters-bar">
      <mat-form-field class="filter-field">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="filterEntityType" (selectionChange)="applyFilters()">
          <mat-option value="">All Types</mat-option>
          <mat-option *ngFor="let t of entityTypes" [value]="t">{{ t }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>Action</mat-label>
        <mat-select [(ngModel)]="filterAction" (selectionChange)="applyFilters()">
          <mat-option value="">All Actions</mat-option>
          <mat-option *ngFor="let a of actions" [value]="a">{{ formatAction(a) }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filterFrom" (dateChange)="applyFilters()">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="filter-field">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="filterTo" (dateChange)="applyFilters()">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button mat-stroked-button (click)="clearFilters()" *ngIf="hasActiveFilters">
        Clear
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Table -->
    <div class="table-container" *ngIf="!isLoading">
      <table mat-table [dataSource]="logs" class="log-table" *ngIf="logs.length > 0">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date / Time</th>
          <td mat-cell *matCellDef="let log" class="date-cell">{{ formatDate(log.createdAt) }}</td>
        </ng-container>

        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>User</th>
          <td mat-cell *matCellDef="let log">{{ log.userName }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let log">
            <span class="action-badge" [ngClass]="getActionBadgeClass(log.action)">
              {{ formatAction(log.action) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="hide-mobile">Type</th>
          <td mat-cell *matCellDef="let log" class="hide-mobile">{{ log.entityType }}</td>
        </ng-container>

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef>Details</th>
          <td mat-cell *matCellDef="let log" class="details-cell">{{ log.details }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <div *ngIf="logs.length === 0" class="empty-state">
        No activity logs found.
      </div>
    </div>

    <!-- Pagination -->
    <mat-paginator
      *ngIf="totalCount > 0"
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[25, 50, 100]"
      (page)="onPage($event)"
      showFirstLastButtons>
    </mat-paginator>
  </main>
</div>
